var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuppliers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#FFF3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 26.1666L22.8334 27.8333C22.9976 27.9974 23.1924 28.1276 23.4069 28.2165C23.6214 28.3053 23.8513 28.351 24.0834 28.351C24.3156 28.351 24.5454 28.3053 24.7599 28.2165C24.9744 28.1276 25.1693 27.9974 25.3334 27.8333C25.4976 27.6691 25.6278 27.4742 25.7166 27.2597C25.8055 27.0453 25.8512 26.8154 25.8512 26.5833C25.8512 26.3511 25.8055 26.1212 25.7166 25.9068C25.6278 25.6923 25.4976 25.4974 25.3334 25.3333",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6666 23.6666L25.7499 25.7499C26.0815 26.0815 26.5311 26.2677 26.9999 26.2677C27.4688 26.2677 27.9184 26.0815 28.2499 25.7499C28.5815 25.4184 28.7677 24.9688 28.7677 24.4999C28.7677 24.0311 28.5815 23.5815 28.2499 23.2499L25.0166 20.0166C24.5479 19.5484 23.9124 19.2855 23.2499 19.2855C22.5874 19.2855 21.952 19.5484 21.4833 20.0166L20.7499 20.7499C20.4184 21.0815 19.9688 21.2677 19.4999 21.2677C19.0311 21.2677 18.5815 21.0815 18.2499 20.7499C17.9184 20.4184 17.7322 19.9688 17.7322 19.4999C17.7322 19.0311 17.9184 18.5815 18.2499 18.2499L20.5916 15.9083C21.3518 15.1501 22.3432 14.6671 23.4088 14.5357C24.4744 14.4044 25.5534 14.6323 26.4749 15.1833L26.8666 15.4166C27.2214 15.6308 27.6433 15.705 28.0499 15.6249L29.4999 15.3333",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5001 14.5L30.3334 23.6667H28.6667",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 14.5L13.6667 23.6667L19.0834 29.0833C19.4149 29.4149 19.8646 29.6011 20.3334 29.6011C20.8023 29.6011 21.2519 29.4149 21.5834 29.0833C21.9149 28.7518 22.1012 28.3022 22.1012 27.8333C22.1012 27.3645 21.9149 26.9149 21.5834 26.5833",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.3333H21.1667",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/suppliers.52264d77a5a1d40b80e71ee8a7a6496d.svg";
export { ForwardRef as ReactComponent };